export const priceMonitorPolicyValidationError = (values) => {
  if (values.paidActiveMonitorLimit < values.freeActiveMonitorLimit) {
    return '会员监控数量不能低于普通用户';
  }
  if (values.paidHistoryDays < values.freeHistoryDays) {
    return '会员历史价格天数不能低于普通用户';
  }
  return null;
};
